import { render, staticRenderFns } from "./projectDynamic.vue?vue&type=template&id=6dc5bf32&scoped=true"
import script from "./projectDynamic.vue?vue&type=script&lang=js"
export * from "./projectDynamic.vue?vue&type=script&lang=js"
import style0 from "./projectDynamic.vue?vue&type=style&index=0&id=6dc5bf32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc5bf32",
  null
  
)

export default component.exports